export interface Parcela {
  contrato: string;
  nrParcela: number;
  vencimento: string;
  atraso: number;
  valorParc: string;
  juros: string;
  multa: string;
  vlrDesconto: string;
  total: string;
  negociado?: boolean;
}

export interface Total {
  nrParcelas: number;
  vencimento: string;
  atraso: number;
  valorParc: string;
  juros: string;
  multa: string;
  vlrDesconto: string;
  total: string;
}

export interface Contrato {
  contrato: string;
  diasAtraso: number;
  minPrincipal: number;
  minJuros: number;
  minMulta: number;
  minTaxas: number;
  maxPrincipal: number;
  maxJuros: number;
  maxMulta: number;
  maxTaxas: number;
  descontoMulta?: number;
  descontoTaxa?: number;
  descontoPrincipal?: number;
  descontoJuros?: number;
  juncao: boolean;
  parcelas: Parcela[];
  negociado?: boolean;
  tabulado?: boolean;
  totalParcelas: Total;
}

export const contratos: Contrato[] = [
  {
    contrato: "32800",
    diasAtraso: 180,
    juncao: true,
    maxJuros: 100,
    maxMulta: 0,
    maxTaxas: 0,
    maxPrincipal: 100,
    minPrincipal: 0,
    minJuros: 0,
    minMulta: 0,
    minTaxas: 0,
    totalParcelas: {
      nrParcelas: 5,
      vencimento: "13/02/2023",
      atraso: 180,
      valorParc: "R$ 86.600,00",
      juros: "R$ 74.900,00",
      multa: "R$ 9.900,00",
      vlrDesconto: "R$ 44.900",
      total: "R$ 119.900,00",
    },
    parcelas: [
      {
        contrato: "32800",
        nrParcela: 1,
        vencimento: "13/02/2023",
        atraso: 180,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "32800",
        nrParcela: 2,
        vencimento: "13/02/2023",
        atraso: 180,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "32800",
        nrParcela: 3,
        vencimento: "13/02/2023",
        atraso: 180,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "32800",
        nrParcela: 4,
        vencimento: "13/02/2023",
        atraso: 180,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "32800",
        nrParcela: 5,
        vencimento: "13/02/2023",
        atraso: 180,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
    ],
  },
  {
    contrato: "32850",
    diasAtraso: 234,
    juncao: false,
    maxJuros: 100,
    maxMulta: 0,
    maxTaxas: 0,
    maxPrincipal: 100,
    minPrincipal: 0,
    minJuros: 0,
    minMulta: 0,
    minTaxas: 0,
    totalParcelas: {
      nrParcelas: 5,
      vencimento: "13/02/2023",
      atraso: 234,
      valorParc: "R$ 86.600,00",
      juros: "R$ 74.900,00",
      multa: "R$ 9.900,00",
      vlrDesconto: "R$ 44.900",
      total: "R$ 119.900,00",
    },
    parcelas: [
      {
        contrato: "32850",
        nrParcela: 1,
        vencimento: "13/02/2023",
        atraso: 234,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "32850",
        nrParcela: 2,
        vencimento: "13/02/2023",
        atraso: 234,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "32850",
        nrParcela: 3,
        vencimento: "13/02/2023",
        atraso: 234,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "32850",
        nrParcela: 4,
        vencimento: "13/02/2023",
        atraso: 234,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "32850",
        nrParcela: 5,
        vencimento: "13/02/2023",
        atraso: 234,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
    ],
  },
  {
    contrato: "31350",
    diasAtraso: 120,
    juncao: true,
    maxJuros: 100,
    maxMulta: 0,
    maxTaxas: 0,
    maxPrincipal: 100,
    minPrincipal: 0,
    minJuros: 0,
    minMulta: 0,
    minTaxas: 0,
    totalParcelas: {
      nrParcelas: 5,
      vencimento: "13/02/2023",
      atraso: 120,
      valorParc: "R$ 86.600,00",
      juros: "R$ 74.900,00",
      multa: "R$ 9.900,00",
      vlrDesconto: "R$ 44.900",
      total: "R$ 119.900,00",
    },
    parcelas: [
      {
        contrato: "31350",
        nrParcela: 1,
        vencimento: "13/02/2023",
        atraso: 120,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "31350",
        nrParcela: 2,
        vencimento: "13/02/2023",
        atraso: 120,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "31350",
        nrParcela: 3,
        vencimento: "13/02/2023",
        atraso: 120,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "31350",
        nrParcela: 4,
        vencimento: "13/02/2023",
        atraso: 120,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
      {
        contrato: "31350",
        nrParcela: 5,
        vencimento: "13/02/2023",
        atraso: 120,
        valorParc: "R$ 17.320,00",
        juros: "R$ 14.980,00",
        multa: "R$ 1.980,00",
        vlrDesconto: "R$ 8.980,00",
        total: "R$ 23.980,00",
      },
    ],
  },
];
